import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { Estado } from 'app/services/cartera/estados.cartera';

@Component({
  selector: 'app-cambio-estado-cobro',
  templateUrl: './cambio-estado-cobro.component.html',
  styleUrls: ['./cambio-estado-cobro.component.scss']
})
export class CambioEstadoCobroComponent implements OnInit {

  newForm: FormGroup;
  public estados:Array<Estado>

  /**
   * Constructor
   * 
   * @param _data 
   * @param {MatDialogRef<CambioEstadoCobroComponent>} _dialog 
   * @param {MatSnackBar} _snackBar 
   * @param {CarteraService} _cartera 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) public _data, 
    public _dialog: MatDialogRef<CambioEstadoCobroComponent>,
    private _snackBar: MatSnackBar,
    private _cartera: CarteraService
  ) 
  {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit() {
    this.getEstadosCartera();
    this.newForm = this.createForm();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Creación del FormGroup
   */
  createForm(): FormGroup {
    return new FormGroup({
      antiguo_estado: new FormControl(this._data.estado_cobro),
      nuevo_estado: new FormControl(),
      fecha_cobro: new FormControl(this._data.fecha),
      radicado: new FormControl(this._data.grugru),
      empresa: new FormControl(this._data.empresa),
      usuario: new FormControl(JSON.parse(localStorage.getItem('usuario'))['id_usuario'])
    });
  }

  /**
   * Cambia el estado al cobro seleccionado
   * @param {any} form 
   */
  public cambioEstado(form: any): void {
    this._cartera.CambiarEstadoCobro(this._data.cobro, form).subscribe((data: any) => {
      if(data.affectedRows > 0){
        this._snackBar.open('Estado del cobro actualizado', 'Aceptar', {
          duration: 2000
        });
        this._dialog.close(true);
      }else{
        this._snackBar.open('Error: No se pudo actualizar el estado', '', {
          duration: 2500,
          panelClass: 'warn-600'
        });
      }
    }); 
  }

  getEstadosCartera(){
    console.log(this._data)
    if(this._data.grugru === undefined || this._data.grugru === null ) {
      this._cartera.getEstadosDiligencias().subscribe(estados=>this.estados = estados);
    }else{
      this._cartera.getEstados().subscribe(estados=>this.estados = estados);
    }
  }
}
